import React from "react";

import Alert from "@mui/material/Alert";
import PasswordInput from "../../components/Input";
import { Grid, TextField, Typography, Box, Button } from "@mui/material";
import { CircularProgress } from "@mui/material";

import { finishLogin } from "../../auth";
import { loginWithEntraID } from "../../components/SSO";

import Header from "../../components/Header";

import api from "../../api";

const MicrosoftLogo = () => (
    <svg width="18" height="18" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="13" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="13" width="9" height="9" fill="#00A4EF" />
        <rect x="13" y="13" width="9" height="9" fill="#FFB900" />
    </svg>
);

class EntraLogin extends React.Component {

    constructor(props) {
        super(props);

        const { vanityUrl } = props.match.params;

        this.state = {
            vanityUrl,
            loading: false,
            configLoading: true,
            configError: false,
            enterpriseName: "",
            showPasswordFields: true,
            logoUrl: null,
            showAlert: "",
            typeAlert: "error",
            username: "",
            password: "",
        };
    }

    async componentDidMount() {
        const { vanityUrl } = this.state;

        try {
            const res = await api.get(`/api/enterprise/entra_config/${vanityUrl}/`);
            this.setState({
                configLoading: false,
                enterpriseName: res.data.enterprise_name,
                showPasswordFields: res.data.show_password_fields,
                logoUrl: res.data.logo_url || null,
            });
        } catch {
            this.setState({ configLoading: false, configError: true });
        }
    }

    setShowAlert = (type, value) => {
        this.setState({ typeAlert: type, showAlert: value });
    }

    handleEntraLogin = () => {
        this.setState({ loading: true });
        loginWithEntraID({
            vanityUrl: this.state.vanityUrl,
            finishLogin,
            setShowAlert: (msg) => {
                this.setState({ loading: false });
                this.setShowAlert("error", msg);
            },
            setLoading: (val) => this.setState({ loading: val }),
        });
    }

    handlePasswordLogin = () => {
        const { username, password } = this.state;

        if (!username) {
            this.setShowAlert("error", "E-mail não informado.");
            return;
        }
        if (!password) {
            this.setShowAlert("error", "Senha não informada.");
            return;
        }

        this.setState({ loading: true });

        fetch("/api/auth/token/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username: username.toLowerCase(), password }),
        })
            .then((res) => {
                if (res.status === 200) return res.json();
                throw res;
            })
            .then(async (data) => {
                await finishLogin(data, this.setShowAlert, (val) => this.setState({ loading: val }));
            })
            .catch(async (err) => {
                this.setState({ loading: false });
                try {
                    const data = await err.json();
                    const detail = Array.isArray(data.detail) ? data.detail : [];
                    const msg = detail.pop();
                    if (msg === "Password authentication not allowed.") {
                        this.setShowAlert("warning", "Sua conta não permite acesso por senha.");
                    } else {
                        this.setShowAlert("error", "Credenciais inválidas.");
                    }
                } catch {
                    this.setShowAlert("error", "Algo deu errado, tente novamente.");
                }
            });
    }

    handleKeyPress = (e) => {
        if (e.key === "Enter") this.handlePasswordLogin();
    }

    render() {
        const {
            configLoading, configError, enterpriseName,
            showPasswordFields, logoUrl, loading, showAlert, typeAlert,
            username, password,
        } = this.state;

        if (configLoading) {
            return (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                    <CircularProgress />
                </Box>
            );
        }

        if (configError) {
            return (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" flexDirection="column">
                    <Typography variant="h5" color="error">Página de login não encontrada.</Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Verifique o link fornecido pela sua empresa.
                    </Typography>
                </Box>
            );
        }

        return (
            <Box display="flex">
                <Header subtitle={enterpriseName} />
                <Box
                    className="form-login"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        minHeight: "100vh",
                        maxWidth: 400,
                        margin: "0 auto",
                        padding: "0 2rem",
                        flex: 1,
                    }}
                >
                    <Grid container spacing={2}>

                        {showAlert && (
                            <Grid item xs={12}>
                                <Alert severity={typeAlert} onClose={() => this.setState({ showAlert: "" })}>
                                    {showAlert}
                                </Alert>
                            </Grid>
                        )}

                        {showPasswordFields && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        label="E-mail"
                                        variant="outlined"
                                        value={username}
                                        onChange={(e) => this.setState({ username: e.target.value })}
                                        onKeyPress={this.handleKeyPress}
                                        fullWidth
                                        size="small"
                                        autoComplete="username"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PasswordInput
                                        label="Senha"
                                        value={password}
                                        onChange={(e) => this.setState({ password: e.target.value })}
                                        onKeyPress={this.handleKeyPress}
                                        fullWidth
                                        size="small"
                                        autoComplete="current-password"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={loading}
                                        onClick={this.handlePasswordLogin}
                                    >
                                        {loading && (
                                            <CircularProgress size={18} sx={{ mr: 1 }} />
                                        )}
                                        Entrar
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Box sx={{ flex: 1, borderBottom: "1px solid #ddd" }} />
                                        <Typography variant="body2" color="text.secondary">ou</Typography>
                                        <Box sx={{ flex: 1, borderBottom: "1px solid #ddd" }} />
                                    </Box>
                                </Grid>
                            </>
                        )}

                        {logoUrl && (
                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                <img
                                    src={logoUrl}
                                    alt={enterpriseName}
                                    style={{ width: "60%", maxWidth: "100%", objectFit: "contain" }}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Button
                                variant="outlined"
                                fullWidth
                                disabled={loading}
                                onClick={this.handleEntraLogin}
                                startIcon={<MicrosoftLogo />}
                                sx={{ textTransform: "none" }}
                            >
                                {loading && !showPasswordFields && (
                                    <CircularProgress size={18} sx={{ mr: 1 }} />
                                )}
                                Entrar com Microsoft
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        );
    }
}

export default EntraLogin;
